const pad = (n) => String(n).padStart(2, "0");

// YYYY-MM-DD in the browser's local time zone (toISOString would give the UTC date).
export const toLocalDateKey = (date = new Date()) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// Parses "YYYY-MM-DD" as a local date; new Date("YYYY-MM-DD") would parse it as UTC midnight.
export const parseLocalDate = (value) => {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return value ? new Date(value) : new Date();
};
